import React from 'react';
import { Label } from '@/components/atoms/texts/label';
import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuTrigger,
} from '@/components/ui/context-menu';
import EditRounded from '@mui/icons-material/EditRounded';
import DeleteRounded from '@mui/icons-material/DeleteRounded';
import { Button } from '@/components/molecules/buttons/button';

const getAmountString = (payload) => {
    const amount = payload?.amountEur ?? payload?.amount ?? null;
    const currency = '€';

    if (amount == null) {
        return { amountStr: '—', isPositive: false };
    }

    return {
        amountStr: `${Number(amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`,
        isPositive: Number(amount) > 0,
    };
};

const getPeriodLabel = (payload) => {
    if (payload?.operationType !== 'PAY_INTERESTS' || !payload.linkedEntityPeriod) {
        return null;
    }

    const date = new Date(payload.linkedEntityPeriod);
    const year = date.getFullYear();
    const monthKey = date.toLocaleString('en-US', { month: 'long' }).toLowerCase();

    return (
        <span className="flex items-center gap-betweenText">
            <Label color="disabled" size="small" message={`global.months.${monthKey}`} />
            <Label color="disabled" size="small">{year}</Label>
        </span>
    );
};

export default function OperationItem({ item, setDetailledEvent, canManage, onEdit, onDelete }) {
    const { kind, payload } = item;
    const [isHovered, setIsHovered] = React.useState(false);

    if (kind === 'interest') {
        return null;
    }

    const { amountStr, isPositive } = getAmountString(payload);
    const periodLabel = getPeriodLabel(payload);

    return (
        <ContextMenu>
            <ContextMenuTrigger
                className="flex items-center justify-between gap-firstDegree p-firstDegree min-h-[52px] hover:cursor-pointer hover:border-2 hover:border-white hover:bg-medium hover:backdrop-blur-md rounded-sm relative "
                onClick={() => { setDetailledEvent(payload || undefined); }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className="flex items-center justify-start gap-firstDegree grow">
                    <Label fontWeight="semibold" message={`consultants.statement.statementOperations.statementOperationType_${payload.operationType || 'interets'}`} />
                    {periodLabel}
                    {item.payload?.comment && (
                        <Label size="small" color="disabled">{item.payload?.comment}</Label>
                    )}
                    {item.payload.impactsOverflow == false && (
                        <Label size="small" color="disabled" message="consultants.expense.notImpactsOverflow" />
                    )}
                </div>
                {isHovered && canManage && (
                    <div className="flex items-center gap-betweenText w-fit ">
                        <Button
                            style="ghost"
                            sizePadding="small"
                            showLeftIcon
                            leftIcon={<EditRounded fontSize="small" />}
                            showText={false}
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit?.(payload);
                            }}
                        />
                        {payload?.editable !== false && !payload?.linkedEntityUuid && (
                            <Button
                                style="ghost"
                                sizePadding="small"
                                showLeftIcon
                                leftIcon={<DeleteRounded fontSize="small" />}
                                showText={false}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete?.(payload);
                                }}
                            />
                        )}
                    </div>
                )}
                <Label fontWeight="medium" className={isPositive && 'text-green-500'}>{amountStr}</Label>
            </ContextMenuTrigger>
            <ContextMenuContent className="w-52">
                <ContextMenuItem inset onClick={() => { navigator.clipboard.writeText(payload?.uuid || ''); }}>
                    <Label>Copier l'identifiant</Label>
                </ContextMenuItem>
            </ContextMenuContent>
        </ContextMenu>
    );
}